import { render, staticRenderFns } from "./EditPersonalNotesDialog.vue?vue&type=template&id=eef4ca70"
import script from "@/views/Webshop/OrderDetail/EditPersonalNotesDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Webshop/OrderDetail/EditPersonalNotesDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Webshop/OrderDetail/edit-personal-notes-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports